import { tss } from "tss-react/mui";

export const useBlogArticleGridSectionStyles = tss.withName("BlogArticleGridSection").create(({ theme }) => ({
    filterRow: {
        display: "flex",
        flexWrap: "wrap" as const,
        gap: theme.spacing(1),
        marginBottom: theme.spacing(5),
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: theme.spacing(4),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    noResults: {
        color: theme.palette.text.secondary,
        textAlign: "center" as const,
        padding: theme.spacing(6, 0),
    },
}));
